// TODO: sharing tree structure config is a bad idea - refactor to make flat key-value list

let gConfig = null;
const getConfig = () => gConfig || {};

export const setConfig = (config) => {
  gConfig = config;
};

export const isQuicken = () => getConfig().client?.product === 'QUICKEN';
export const isSimplifi = () => !isQuicken();

export const isMobile = () => {
  const config = getEnvironmentConfig();
  return config?.client_id?.includes?.('ios') || config?.client_id?.includes?.('android') || false;
};
export const isWeb = () => getEnvironmentConfig()?.client_id?.includes?.('web') || false;

export const getBuildConfig = () => getConfig().builds?.[getConfig().client?.build_type];
export const getClientConfig = () => getConfig().client;
export const getCommonConfig = () => getConfig().common;
export const getEnvironmentConfig = () => getConfig().environments?.[getConfig().client?.environment];
export const getHostConfig = () => getConfig().hosts?.[getConfig().client?.hostname];

export const getRedirectUrl = () =>
  `${getConfig().client?.protocol}//${getConfig().client?.hostname}${
    getConfig().client?.port ? `:${getConfig().client?.port}` : ''
  }`;
export const isDevMode = () =>
  getConfig().client?.build_type === 'development' || getConfig().client?.environment !== 'prod';
export const isDevBuild = () => getConfig().client?.build_type === 'development';

export { gConfig as default };
